const WorkspaceMigrationTelemetryEventNames = {
  WSMigration_GetWorkspaceMigrationStatus_loaded: "WSMigration_GetWorkspaceMigrationStatus_loaded",
  WSMigration_GetWorkspaceMigrationStatus_failed: "WSMigration_GetWorkspaceMigrationStatus_failed",
  WSMigration_GetExperimentationGroup_moved: "WSMigration_GetExperimentationGroup_moved",
  WSMigration_WorkspaceMigrationEntityRedirect_redirect: "WSMigration_WorkspaceMigrationEntityRedirect_redirect",
  WSMigration_WorkspaceMigrationEntityRedirect_render: "WSMigration_WorkspaceMigrationEntityRedirect_render",
  WSMigration_WorkspaceMigrationGenericRedirect_redirect: "WSMigration_WorkspaceMigrationGenericRedirect_redirect",
  WSMigration_WorkspaceMigrationRedirect_url: "WSMigration_WorkspaceMigrationRedirect_url",
  WSMigration_WorkspaceMigrationGenericRedirect_render: "WSMigration_WorkspaceMigrationGenericRedirect_render",
  /**
   * Banners
   */
  WSMigration_WorkspacePendingMigrationBanner: "WSMigration_WorkspacePendingMigrationBanner",
  WSMigration_WorkspacePendingMigrationBanner_dismiss: "WSMigration_WorkspacePendingMigrationBanner_dismiss",
  WSMigration_WorkspaceMigratingBanner: "WSMigration_WorkspaceMigratingBanner",
  WSMigration_WorkspaceMigratingBanner_dismiss: "WSMigration_WorkspaceMigratingBanner_dismiss",
  WSMigration_WorkspaceRedirectBanner: "WSMigration_WorkspaceRedirectBanner",
  WSMigration_WorkspaceRedirectBanner_dismiss: "WSMigration_WorkspaceRedirectBanner_dismiss"
};
export {
  WorkspaceMigrationTelemetryEventNames
};
//# sourceMappingURL=WorkspaceMigrationTelemetryEventNames.js.map
